import React, { HTMLAttributes } from 'react'
import LazyLoad, { LazyLoadProps } from 'react-lazyload'

interface CustomProps {
  /**
   * Url to webp image
   */
  webpSrc: string
  /**
   * Url to png image
   */
  pngSrc: string
  /**
   * Alternate text for an image
   */
  alt: string
  /**
   * Optional props for lazy loading, pls check https://www.npmjs.com/package/@types/react-lazyload
   */
  lazy?: boolean | LazyLoadProps
  width?: number
  height?: number
}

export type PictureProps = CustomProps & HTMLAttributes<HTMLPictureElement>

const LazyLoadingStandardProps: Partial<LazyLoadProps> = {
  once: true,
  throttle: true,
}

const PicturePrv = ({ lazy, webpSrc, pngSrc, alt, width, height, ...rest }: PictureProps) => {
  const Pic = (
    <picture {...rest}>
      <source srcSet={webpSrc} type="image/webp" />
      <source srcSet={pngSrc} type="image/png" />
      <img width={width} height={height} src={pngSrc} alt={alt} />
    </picture>
  )

  const lazyProps = typeof lazy === 'boolean' ? LazyLoadingStandardProps : { ...LazyLoadingStandardProps, ...lazy }

  return lazy ? <LazyLoad {...lazyProps}>{Pic}</LazyLoad> : Pic
}

PicturePrv.displayName = 'Picture'

const Picture = React.memo(PicturePrv)

export default Picture
